export default {
  futuresStrategy: {
    futuresStrategyList: {
      search: {
        departmentName: '业务部门',
        ptcombiNo: '策略编号', //策略号/组合序号
        combiName: '策略名称',
        projectName: '项目名称',
        exchangeTypeMode: '策略模式',
        // a: "市场基差",
        // a: "开仓基差",
        exposureAmount: '数量敞口（吨）',
        exposureBalance: '货值敞口',
        // a: "合同执行情况",
        // a: "预警提示",
        contractNo: '合同编号',
        initDate: '交易日期',
        // a: "持仓方向",
        // a: "合计潜盈亏",
        // a: "合计盈亏",
        equal: '等于',
        notEqual: '不等于',
        gt: '大于',
        lt: '小于',
      },
      placeholder: {
        departmentCode: '请选择业务部门',
      },
      table: {
        departmentName: '业务部门',
        projectName: '项目名称',
        ptcombiNo: '策略编号',
        combiName: '策略名称',
        exchangeTypeMode: '策略模式',
        buyQuantity: '期货买量(吨)',
        sellQuantity: '期货卖量(吨)',
        holdQuantity: '期货净持仓(吨)',
        holdIncomeFloat: '期货浮动盈亏(万元)',
        monthDropIncome: '当月平仓盈亏(万元)',
        goodsQuantity: '现货数量(吨)',
        goodsProtentialIncome: '现货潜盈亏(万元)',
        goodsActualIncome: '现货实现盈亏(万元)',
        protentialIncome: '潜盈亏合计(万元)',
        incomeSum: '盈亏合计(万元)',
        exposureAmount: '敞口数量(吨)',

        initDate: '交易日期',
        exchangeType: '交易类别',
        futuCode: '合约代码',
        futuCodeBasis: '商品代码',
        openPrice: '开仓价差',
        marketPrice: '市场价差',
        holdPrice: '持仓价差',
        dropPrice: '平仓价差',
        openPriceBasis: '开仓基差',
        marketPriceBasis: '市场基差',
        holdPriceBasis: '持仓基差',
        dropPriceBasis: '平仓基差',
        // holdIncomeFloat: '浮动盈亏',
        actualIncome: '实现盈亏',
        // incomeSum: '总盈亏',
        // exposureBalance: '敞口金额',
        stockName: '合约名称', //证券名称
        stockNameBasis: '商品名称', //证券名称
        moneyType: '币种',
        combiHoldType: '持仓方向',
        combiAssetKind: '组合资产类型',
        branchNo: '分支机构',
        prodAccount: '产品账号',
        productName: '产品名称',
        branchName: '机构名称',
        squarePrice: '市场价格', //结算价
        averageOpenPrice: '开仓价格',
        openAmount: '开仓数量',
        sumOpenAmount: '累计开仓数量',
        sumAverageOpenPrice: '累计开仓均价',
        averageHoldPrice: '持仓均价',
        currentAmount: '持仓数量',
        averageDropPrice: '平仓均价',
        dropAmount: '平仓数量',
        sumDropAmount: '累计平仓数量',
        sumAverageDropPrice: '累计平仓均价',
        dropIncomeAdd: '累计平仓盈亏',
        totalFare: '手续费',
        modifyDate: '持仓更新日期',
        modifyDateBasis: '库存更新日期',
        closePrice: '期货收盘价',

        contractNo: '合同编号',
        contractDetailNo: '合同行', //销售合同行项目编号
        productNo: '商品编码',
        productDesc: '商品描述',
        productQuantity: '商品数量',
        contractCategory: '采购或者销售',
        contractDetailCategory: '合同类型', //意向单,合同,协议,订单
        contractDate: '合同日期',
        contractStatus: '合同执行情况',
        openInformation: '开仓信息',
        holdInformation: '持仓信息',
        netValue: '净值',
        exposureBalance: '敞口金额',
        commodityCode: '商品代码',
        commodityName: '商品名称',
        extCommodityCode: '外部商品代码',
        commodityType: '商品类型',
        commodityModel: '规格型号',
        commodityBrand: '商品品牌',
        commodityRank: '商品等级',
        commodityMaterial: '商品材质',
        commodityArea: '产地',
        areaCode: '区域代码',
        lastPrice: '最新价',
        preClosePrice: '昨收盘',
        hqDate: '行情日期',
        positionStr: '定位串',
      },
    },
    strategicContract: {
      column: {
        tenantCode: '租户编码',
        companyCode: '公司编码',
        departmentCode: '部门编码',
        companyName: '公司名',
        departmentName: '业务部门',
        gmtCreate: '记录创建时间',
        gmtModified: '记录更新时间',
        lastModifiedBy: '记录最后更新人',
        isDeleted: '是否删除(1删除,0未删除)',
        sortNo: '序号',
        version: '版本',
        branchNo: '分支机构',
        ptcombiNo: '策略编号', //策略号/组合序号
        combiName: '策略名称', //策略名称/组合名称
        projectName: '项目名称',
        prodAccount: '产品账号',
        productName: '产品名称',
        exchangeTypeMode: '策略模式', //交易所模式
        busiRiskLevel: '业务风险度划分',
        relationPtcombiNo: '关联组合序号',
        exchEnFutucodeType: '允许的合约类别列表',
        enableStatus: '可用状态',

        contractNo: '合同编号',
        contractDetailNo: '合同行', //销售合同行项目编号
        productNo: '商品编码',
        productDesc: '商品描述',
        productQuantity: '商品数量',
        contractCategory: '采购或者销售',
        contractDetailCategory: '合同类型', //意向单,合同,协议,订单
        contractDate: '合同日期',
        contractStatus: '合同执行情况',
        exposureAmount: '敞口数量',
        exposureBalance: '敞口金额',
        purchaseCount: '采购合同数量合计',
        purchaseAmount: '采购合同金额',
        salesCount: '销售合同数量合计',
        salesAmount: '销售合同金额',
      },
      placeholder: {
        tenantCode: '请输入租户编码',
        companyCode: '请输入公司编码',
        departmentCode: '请输入部门编码',
        companyName: '请输入公司名',
        departmentName: '请输入部门名',
        gmtCreate: '请选择记录创建时间',
        gmtModified: '请选择记录更新时间',
        lastModifiedBy: '请输入记录最后更新人',
        isDeleted: '请输入是否删除(1删除,0未删除)',
        sortNo: '请输入序号',
        version: '请输入版本',
        branchNo: '请输入分支机构',
        ptcombiNo: '请输入策略号/组合序号',
        combiName: '请输入策略名称/组合名称',
        projectName: '请输入项目名称',
        prodAccount: '请输入产品账号',
        productName: '请输入产品名称',
        exchangeTypeMode: '请输入交易所模式',
        busiRiskLevel: '请输入业务风险度划分',
        relationPtcombiNo: '请输入关联组合序号',
        exchEnFutucodeType: '请选择允许的合约类别列表',
        enableStatus: '请选择可用状态',

        contractNo: '请输入合同号',
        contractDetailNo: '请输入销售合同行项目编号',
        productNo: '请输入商品编码',
        productDesc: '请输入商品描述',
        productQuantity: '请输入商品数量',
        contractCategory: '请输入采购或者销售',
        contractDetailCategory: '请输入意向单,合同,协议,订单',
        contractDate: '请选择合同日期',
      },
    },
    collapseTitle: {
      addStrategicTitle: '新增匹配关系',
      contractTitle: '合同明细',
      matchContractTitle: '匹配合同',
      futuresAndCurrent: '期现信息',
      baseTitle: '基本信息',
      informationTitle: '策略信息分类',
      currentTitle: '现货信息',
      futuresTitle: '期货信息',
      holdInfo: '持仓信息',
    },
    message: {
      noContract: '请选择关联的合同',
      hasExist: '存在重复数据，请检查！',
    },
    button: {
      add: '新增',
      delete: '删除',
    },
    router: {
      edit: '修改',
      add: '新增',
    },
  },
};
